import {Component, Input} from '@angular/core';
import {DecimalPipe} from '@angular/common';
import {CardItem} from '../../attendance/my-score/summary-card/summary-card.component';

@Component({
    selector: 'app-dashboard-tiles',
    imports: [DecimalPipe],
    templateUrl: './dashboard-tiles.component.html',
    styles: [`
        :host { display: block; height: 100%; }
        .tiles { display: grid; grid-template-columns: repeat(2, 1fr); grid-auto-flow: column; gap: 1.5rem; height: 100%; }
        @media (max-width: 575.98px) {
            .tiles { grid-template-columns: 1fr; grid-auto-flow: row; grid-template-rows: none !important; }
        }
    `],
})
export class DashboardTilesComponent {
    @Input() items: CardItem[] = [];

    // The tiles are listed three to a row on the My Score pages; filling by column keeps those rows as the two columns here.
    protected get rows(): number {
        return Math.ceil(this.items.length / 2);
    }
}
